'use client';

import { Container, Space, Stack, Text, Title } from '@mantine/core';

import { Footer, WaitlistForm } from '@/components';
import LogoHeader from '@/public/assets/logo-header.svg';

import styles from './LandingPageContent.module.css';

const LandingPageContent = () => {
  return (
    <div
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      {/* Ron was here */}
      <Container
        size="lg"
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Stack
          align="center"
          w="100%"
          ta="center"
        >
          <LogoHeader
            className={styles.logo}
            width={203}
            height={73}
          />
          <Space h="xs" />
          <Title
            order={1}
            variant="hero"
          >
            Reimagine Democracy
          </Title>
          <Text size="xl">Turn social support into electoral influence.</Text>
          <Space h="lg" />
          <WaitlistForm showLogo={false} />
        </Stack>
      </Container>

      {/* Footer naturally at the bottom, not fixed */}
      <div style={{ padding: '1rem' }}>
        <Footer isDesktopView={true} />
      </div>
    </div>
  );
};

export { LandingPageContent };
